module.exports = __webpack_public_path__ + "static/media/flight-1.41464727.jpg";